import {
  LayoutDashboard,
  Users,
  FileText,
  Building2,
  User,
  ShoppingCart,
  LayoutGrid,
  HardDrive,
  PenTool,
  Clock,
  SlidersHorizontal,
} from 'lucide-react';
import { CommandPaletteItem } from 'types/commandPalette';
import { ROUTES } from 'utils/constants';

export const commandPaletteItems: CommandPaletteItem[] = [
  {
    id: 'dashboard',
    title: 'Dashboard',
    keywords: ['home', 'overview', 'main', 'start'],
    icon: LayoutDashboard,
    path: ROUTES.DASHBOARD,
    section: 'Pages',
  },
  {
    id: 'membership',
    title: 'Member List',
    keywords: ['members', 'master data', 'subscription', 'membership'],
    icon: Users,
    path: ROUTES.MEMBERSHIP.ROOT,
    section: 'Pages',
  },
  {
    id: 'website-builder',
    title: 'Website Builder',
    keywords: [
      'website',
      'builder',
      'church',
      'sections',
      'templates',
      'no ai',
    ],
    icon: PenTool,
    path: ROUTES.MEMBERSHIP.WEBSITE_BUILDER,
    section: 'Pages',
  },
  {
    id: 'record-sale',
    title: 'Record Sale',
    keywords: ['new sale', 'create sale', 'revenue', 'income', 'sell'],
    icon: ShoppingCart,
    path: ROUTES.SALES.ADD,
    section: 'Actions',
  },
  {
    id: 'inventory-report',
    title: 'Inventory Report',
    keywords: ['stock report', 'inventory summary', 'product report'],
    icon: FileText,
    path: ROUTES.REPORTS.INVENTORY_REPORT,
    section: 'Reports',
  },
  {
    id: 'storage',
    title: 'Storage',
    keywords: ['files', 'upload', 'storage provider', 's3', 'r2', 'minio'],
    icon: HardDrive,
    path: ROUTES.STORAGE.ROOT,
    section: 'Pages',
  },
  {
    id: 'schedules',
    title: 'Schedules',
    keywords: ['cron', 'scheduler', 'webhook', 'automation', 'jobs'],
    icon: Clock,
    path: ROUTES.SCHEDULES.ROOT,
    section: 'Pages',
  },
  {
    id: 'companies',
    title: 'Companies',
    keywords: ['business', 'organization', 'company list', 'switch company'],
    icon: Building2,
    path: ROUTES.COMPANIES.ROOT,
    section: 'Account',
  },
  {
    id: 'view-profile',
    title: 'View Profile',
    keywords: ['account', 'settings', 'user', 'my profile', 'personal'],
    icon: User,
    path: ROUTES.USER.PROFILE,
    section: 'Account',
  },
  {
    id: 'app-settings',
    title: 'App Settings',
    keywords: ['preferences', 'beta', 'feature flags', 'settings'],
    icon: SlidersHorizontal,
    path: ROUTES.USER.SETTINGS,
    section: 'Account',
  },
  {
    id: 'kanban',
    title: 'Kanban',
    keywords: ['board', 'trello', 'columns', 'cards', 'drag', 'drop', 'others'],
    icon: LayoutGrid,
    path: ROUTES.KANBAN,
    section: 'Others',
  },
];
